<template>
    <div class="NotFound">
        <div class="container">
            <h2>Whoops!</h2>
            <h5>Page Not Found</h5>
            <router-link to="/"><el-button type="primary">Back to Home Finder<i class="el-icon-arrow-right el-icon-right"></i></el-button></router-link>
        </div>
    </div>
</template>



<script>
    export default {
        data() {
            return {
                activeNames: ['1']
            };
        },
        head: {
            title: function() {
                return {
                    inner: '404'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .NotFound {
        text-align: center;
        padding: 1em 0;

        h2, h5 {
            margin: 0;
        }

        h2 {
            margin-top: 1em;
        }

        .el-button {
            margin-top: 2em;
        }

        .el-icon-right {
            padding-left: 1em;
        }
    }
</style>